import { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import axios from '../api/axiosInstance';

function getLocalDateTimeString() {
  const now = new Date();
  const offset = now.getTimezoneOffset();
  const localDate = new Date(now.getTime() - offset * 60000);
  return localDate.toISOString().slice(0, 16);
}

function WeightForm() {
  const navigate = useNavigate();
  const [userName, setUserName] = useState("訪客");
  const [form, setForm] = useState({
    weightInKg: '',
    pound: '',
    jin: '',
    notes: '',
    recordedAt: getLocalDateTimeString(),
  });
  const [activeField, setActiveField] = useState("weightInKg");

  const updateFields = (field, value) => {
    if (value === '') {
      setForm(prev => ({ ...prev, weightInKg: '', pound: '', jin: '' }));
      return;
    }

    let kg = 0;
    if (field === "weightInKg") kg = parseFloat(value);
    if (field === "pound") kg = parseFloat(value) / 2.20462;
    if (field === "jin") kg = parseFloat(value) / 2;

    if (!isNaN(kg)) {
      setForm(prev => ({
        ...prev,
        weightInKg: field === "weightInKg" ? value : kg.toFixed(2),
        pound: field === "pound" ? value : (kg * 2.20462).toFixed(1),
        jin: field === "jin" ? value : (kg * 2).toFixed(1),
      }));
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (["weightInKg", "pound", "jin"].includes(name)) {
      setActiveField(name);
      updateFields(name, value);
    } else {
      setForm(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const token = localStorage.getItem('token');
    if (!token) return alert('請先登入');

    const payload = {
      weightInKg: parseFloat(form.weightInKg),
      notes: form.notes,
      recordedAt: form.recordedAt
    };

    const response = await axios.post('/api/Weight', payload, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 200) {
      alert('新增成功');
      navigate("/weight/history");
    } else {
      alert('新增失敗');
    }
  };

  useEffect(() => {
    document.title = "新增體重紀錄 - {userName}";

    try {
      const user = JSON.parse(localStorage.getItem("user"));
      if (user?.name) {
        setUserName(user.name);
      }
    } catch (err) {
      console.error("讀取 user 發生錯誤", err);
    }
  }, []);

  return (
    <div className="container mt-4">
      <h2 className="mb-3">新增體重紀錄 - {userName}</h2>

      <div className="mb-3">
        <button className="btn btn-success me-2" onClick={() => navigate("/weight/history")}>
          體重歷史記錄
        </button>
        <button className="btn btn-outline-secondary" onClick={() => navigate("/dashboard")}>
          回到目錄
        </button>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="form-label">公斤 (kg)</label>
          <input
            type="tel"
            inputMode="decimal"        // 提示帶小數點的鍵盤
            pattern="[0-9]*[.,]?[0-9]*"// 基本驗證：數字 + 可選一個小數點
            step="0.1"
            className="form-control"
            name="weightInKg"
            value={form.weightInKg}
            onChange={handleChange}
            required
          />
        </div>

        <div className="mb-3">
          <label className="form-label">磅 (lb)</label>
          <input
            type="tel"
            inputMode="decimal"        // 提示帶小數點的鍵盤
            pattern="[0-9]*[.,]?[0-9]*"// 基本驗證：數字 + 可選一個小數點
            step="0.1"
            className="form-control"
            name="pound"
            value={form.pound}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label className="form-label">斤</label>
          <input
            type="tel"
            inputMode="decimal"        // 提示帶小數點的鍵盤
            pattern="[0-9]*[.,]?[0-9]*"// 基本驗證：數字 + 可選一個小數點
            step="0.1"
            className="form-control"
            name="jin"
            value={form.jin}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label className="form-label">備註</label>
          <input
            type="text"
            className="form-control"
            name="notes"
            value={form.notes}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label className="form-label">紀錄時間</label>
          <input
            type="datetime-local"
            className="form-control"
            name="recordedAt"
            value={form.recordedAt}
            onChange={handleChange}
            required
          />
        </div>

        <button type="submit" className="btn btn-primary">送出</button>
      </form>
    </div>
  );
}

export default WeightForm;
